var map = {
	"./bg1.webp": "9119",
	"./bg2.webp": "0f8c",
	"./bg3.webp": "3cf4",
	"./logo.webp": "4841",
	"./photo/photo-1-1.webp": "aa26",
	"./photo/photo-1-2.webp": "0006",
	"./photo/photo-2-1.webp": "cd65",
	"./photo/photo-2-2.webp": "e414",
	"./photo/photo-3-1.webp": "979c",
	"./photo/photo-4-1.webp": "aa83",
	"./photo/photo-4-2.webp": "003a",
	"./photo/photo-5-1.webp": "cf5b",
	"./photo/photo-6-1.webp": "750c",
	"./photo/photo-7-1.webp": "be93",
	"./photo/photo-7-2.webp": "6039",
	"./photo/photo-8-1.webp": "c310",
	"./photo/photo-9-1.webp": "91d9",
	"./share.webp": "af63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac27";